import { useLoginStatus } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { LoginStatus } from "@website/store/store";
import { Button } from "@website/ui/button";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { useClientLoaded } from "@website/utils/client-loaded/useClientLoaded";
import { ProfileMenu } from "@website/widget/header/components/profile-menu";
import { useLoginModal } from "@website/widget/login";
import { useState } from "react";

export function HeaderLogin() {
  const { onLoginModalOpen } = useLoginModal();
  const { loginStatus } = useLoginStatus();
  const { clientLoaded } = useClientLoaded();
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(false);
  const isB2BOrTelesale = isChannel(["telesale", "b2b"]);

  function toggleProfileMenu() {
    if (isB2BOrTelesale) {
      window.location.href = "/profile";
    } else {
      setIsProfileMenuVisible((previousState) => !previousState);
    }
  }

  if (!clientLoaded || loginStatus === LoginStatus.Pending) {
    return (
      <>
        <div className="lg:hidden">
          <Skeleton height={36} width={36} shape="circle" />
        </div>
        <div className="hidden lg:flex">
          <Skeleton height={40} width={111} className="rounded-full" />
        </div>
      </>
    );
  }

  if (loginStatus === LoginStatus.Success) {
    return (
      <div className="relative">
        {/* mobile */}
        <Button
          EndIcon={<MaterialIcon name="person_outline" variant="outlined" />}
          aria-label="حساب کاربری"
          className="!mx-0 lg:!hidden"
          color="neutral"
          equalDimension
          href="/profile"
          role="link"
          size="medium"
          variant="round-outline"
        />

        {/* desktop */}
        <Button
          EndIcon={<MaterialIcon name="keyboard_arrow_down" />}
          StartIcon={<MaterialIcon name="person" />}
          className="max-lg:!hidden"
          color="secondary"
          onClick={toggleProfileMenu}
          role="button"
          size="medium"
          variant="round-outline"
        >
          حساب کاربری
        </Button>

        {!isB2BOrTelesale && (
          <ProfileMenu
            isOpen={isProfileMenuVisible}
            close={toggleProfileMenu}
          />
        )}
      </div>
    );
  }

  return (
    <>
      {/*mobile*/}
      <Button
        EndIcon={<MaterialIcon name="person" />}
        aria-label={`ورود | ثبت نام`}
        className="!mx-0 lg:!hidden"
        color="secondary"
        equalDimension
        onClick={onLoginModalOpen}
        role="button"
        target="_blank"
        variant="round"
      />

      {/*desktop*/}
      <Button
        aria-label={`ورود و ثبت نام`}
        className="max-lg:!hidden"
        color="secondary"
        onClick={onLoginModalOpen}
        size="medium"
        target="_blank"
        variant="round"
      >
        ورود | ثبت نام
      </Button>
    </>
  );
}
